import Button from "components/base/Button";
import Status from "components/base/Status";

const fields = [
  { key: "hsCode", label: "HS Code" },
  { key: "hsCodeForEu", label: "HS Code (EU)" },
  { key: "hsCodeForUs", label: "HS Code (US)" },
  { key: "customsName", label: "Customs Name" },
  { key: "customsBrand", label: "Customs Brand" },
  { key: "customsUsage", label: "Customs Usage" },
  { key: "customsValue", label: "Customs Value" },
  { key: "customsSize", label: "Customs Size" },
  { key: "customsMaterials", label: "Customs Materials" },
];

function parseLogisticsData(raw) {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

const ConfirmImportFromGTMProjectView = ({ project, onConfirm }) => {
  const logisticsData = parseLogisticsData(project.logisticsData);

  return (
    <div className="text-sm">
      <div className="space-y-1">
        <div className="flex items-center space-x-3">
          <span className="font-semibold">Stage:</span>
          <Status status={project.state} />
        </div>
        {!project.logisticsConfirmedAt && (
          <div className="pt-1">
            <p className="text-orange-600 font-semibold">
              ⚠️ Logistics data for this project has not been confirmed yet.
            </p>
          </div>
        )}
      </div>

      <div className="mt-4 -mx-[1px]">
        <table className="w-full border dark:border-gray-700">
          <tbody>
            {fields.map((field) => (
              <tr key={field.key} className="border-t first:border-t-0">
                <td className="w-52 px-3 py-2 font-semibold bg-gray-50 dark:bg-gray-900">
                  {field.label}
                </td>
                <td className="px-3 py-2 break-words">
                  {logisticsData?.[field.key] ? logisticsData[field.key] : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {logisticsData === null && (
        <div className="mt-3 text-red-600">
          Failed to parse logistics data from this GTM project.
        </div>
      )}

      <div className="mt-6">
        <div>Import logistics data from GTM project into the product line?</div>

        <Button
          className="mt-2"
          primary
          onClick={() => onConfirm(logisticsData)}
          disabled={logisticsData === null}
        >
          Yes, Import Now
        </Button>
      </div>
    </div>
  );
};

export default ConfirmImportFromGTMProjectView;
